import styled from 'styled-components';

export const Container = styled.main`
	background: #f1f5f9;
	min-height: 100vh;
	padding: 48px 20px;
`;

export const Document = styled.article`
	background: #ffffff;
	border: 1px solid #dbe4ef;
	border-radius: 12px;
	box-shadow: 0 14px 36px rgba(15, 23, 42, 0.08);
	color: #1e293b;
	line-height: 1.65;
	margin: 0 auto;
	max-width: 900px;
	padding: 56px 72px;

	p {
		font-size: 16px;
		margin: 0 0 16px;
	}

	a {
		color: #075985;
		font-weight: 600;
	}

	@media (max-width: 640px) {
		padding: 32px 24px;
	}
`;

export const Header = styled.header`
	border-bottom: 3px solid #0f766e;
	margin-bottom: 34px;
	padding-bottom: 24px;

	p {
		color: #0f766e;
		font-size: 14px;
		font-weight: 700;
		letter-spacing: 0.08em;
		margin-bottom: 8px;
		text-transform: uppercase;
	}

	h1 {
		color: #0f172a;
		font-size: clamp(30px, 5vw, 42px);
		letter-spacing: -0.03em;
		line-height: 1.1;
		margin: 0;
	}
`;

export const Meta = styled.p`
	color: #475569;
	font-size: 14px !important;
	margin-top: 16px !important;
`;

export const Section = styled.section`
	border-bottom: 1px solid #e2e8f0;
	padding: 22px 0;

	h2 {
		color: #0f172a;
		font-size: 21px;
		line-height: 1.3;
		margin: 0 0 12px;
	}
`;

export const LanguageSwitcher = styled.div`
	display: flex;
	gap: 8px;
	justify-content: flex-end;
	margin-bottom: 24px;
`;

export const LanguageButton = styled.button<{ $active: boolean }>`
	background: ${({ $active }) => ($active ? '#0f766e' : '#ffffff')};
	border: 1px solid #0f766e;
	border-radius: 999px;
	color: ${({ $active }) => ($active ? '#ffffff' : '#0f766e')};
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	padding: 8px 14px;
`;
